import { t } from "i18next";
import moment from "moment";

import { downloadCsv } from "helpers/Helpers";
import { GetReportRun as GetFacilityReportRun } from "api/rpc/2024-04/facilityAdmin/report/report";
import { GetReportRun as GetClientReportRun } from "api/rpc/2024-04/clientAdmin/report/report";
import { StatusCode } from "api/protocols";
import { TReportAdminScope } from "../reportCatalog.types";
import { TQuickExportRunResult } from "./quickExport.types";

function buildExportFilename(title: string): string {
  return `${title}_${moment(new Date()).format("YYYY-MM-DD")}`.replace(/ /g, "_").toLowerCase();
}

function isDownloadUrl(value: string): boolean {
  return value.startsWith("http://") || value.startsWith("https://");
}

export async function runQuickExport(
  scope: TReportAdminScope,
  params: Record<string, unknown>,
  title: string,
): Promise<TQuickExportRunResult> {
  const response =
    scope === "facility"
      ? await GetFacilityReportRun(params, false)
      : await GetClientReportRun(params, false);

  if (response.status !== StatusCode.OK) {
    return {
      ok: false,
      errorMessage: typeof response.message === "string" ? response.message : t("Error exporting report"),
    };
  }

  const data = response.data;

  if (typeof data === "string") {
    if (isDownloadUrl(data)) {
      window.open(data, "_blank")?.focus();
    } else {
      downloadCsv(data, `${buildExportFilename(title)}.csv`);
    }
    return { ok: true };
  }

  if (data && typeof data === "object" && "message" in data) {
    return {
      ok: false,
      errorMessage: String((data as { message: string }).message),
    };
  }

  return { ok: false, errorMessage: t("Error exporting report") };
}
